import React from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { DetailReadOnlyField } from '../components/DetailFields';
import { detailGrid2 } from '../storeDetailsConstants';
import { formatDetailValue } from '../storeDetailsUtils';

export function HoursSection({ meta, store }) {
  const op = store?.kitchen_operation ?? {};

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <div style={detailGrid2}>
        <DetailReadOnlyField label="Kitchen start date" value={op.kitchen_start_date} />
        <DetailReadOnlyField label="Kitchen end date" value={op.kitchen_end_date} />
        <DetailReadOnlyField label="Operation start time" value={op.operation_start_time} />
        <DetailReadOnlyField label="Operation end time" value={op.operation_end_time} />
        <DetailReadOnlyField
          label="Closed for short time"
          value={op.storeIsClosedForShortTime ? 'Yes' : 'No'}
        />
        <DetailReadOnlyField
          label="Restricted delivery day"
          value={formatDetailValue(op.restrictedDeliveryDay)}
        />
        <DetailReadOnlyField
          label="Restricted delivery start"
          value={formatDetailValue(op.restrictedDeliveryStartTime)}
        />
        <DetailReadOnlyField
          label="Restricted delivery end"
          value={formatDetailValue(op.restrictedDeliveryEndTime)}
        />
      </div>
    </>
  );
}
